// Must be imported before any antd usage: shims ReactDOM.render so antd v5 static methods
// (message / Modal.confirm / notification) work under React 19, which removed the legacy API.
// Without this, static Modal.confirm silently no-ops (no dialog, no error) — e.g. the customer
// "Grant App access" button did nothing.
import '@ant-design/v5-patch-for-react-19';
// Console Glass (task 355.1): self-hosted faces + the theme layer AntD tokens cannot express.
import '@fontsource-variable/ibm-plex-sans';
import '@fontsource-variable/sora';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import './styles/glass.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
